import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";

// export async function fetchContacts({ commit, state, rootState }) {
//     let params = {
//         params: state.params_contacts
//     };

//     await $http
//         .get("/api/terceros", params)
//         .then(response => {
//             commit("setContacts", response.data.data);
//         })
//         .catch(error => {
//             Notification.error({
//                 title: "Error!",
//                 message: error.message,
//                 type: "error",
//                 duration: 1500,
//                 customClass: "notification-box"
//             });
//         });
// }

export async function fetchLines({ commit, state }) {
    await $http
        .get("/api/lista-lineas")
        .then(response => {
            commit("setLines", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function fetchBrands({ commit, state }) {
    await $http
        .get("/api/lista-marcas")
        .then(response => {
            commit("setBrands", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function createDiscount({ commit, state }, params) {
    await $http
        .post("/api/descuentos-por-cliente-marca", params)
        .then(response => {
            commit("setDiscount", response.data.data);
            Notification.success({
                title: "Hecho!",
                message: "Se ha registrado correctamente",
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async  function setPerPagePagination({ commit, dispatch }, perPage) {
    commit("setPerPage", parseInt(perPage.target.value));
    dispatch("fetchDiscounts");

}

export async function setPagePagination({ commit, dispatch }, page) {
    commit("setPage", parseInt(page));
    dispatch("fetchDiscounts");
}


export async function fetchDiscounts({state,commit}){
    state.params.search = state.params && state.params.search ? state.params.search.toUpperCase() : '';
    await $http.get('/api/descuentos-por-cliente-marca',{params:state.params}).then(response=>{
        commit('setDiscounts',response.data.data);
    }).catch(error=>{
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    })
}

export async function fetchDiscount({ commit, state }, id) {
    await $http
        .get(`/api/descuentos-por-cliente-marca/${id}`)
        .then(response => {
            commit("setDiscount", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function updateDiscount({ commit, state }, params) {
    await $http
        .put(`/api/descuentos-por-cliente-marca/${params.id}`, params)
        .then(response => {
            Notification.success({
                title: "Hecho!",
                message: "Se ha actualizado correctamente",
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function deleteDiscount({ commit, state }, id) {
    await $http
        .delete("/api/descuentos-por-cliente-marca/" + id)
        .then(response => {
            Notification.success({
                title: "Hecho!",
                message: "Se ha Eliminado correctamente",
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

// export async function fetchParameters({ commit }, id) {
//     await $http
//         .get(`/api/parametros?paramtable_id=5`)
//         .then(response => {
//             commit("setContacts", response.data.data);
//         })
//         .catch(error => {
//             Notification.error({
//                 title: "Error!",
//                 message: error.message,
//                 type: "error",
//                 duration: 2000,
//                 customClass: "notification-box"
//             });
//         });
// }

export async function getContacts({ commit }, filter) {
    await $http
        .get("/api/terceros", { params: { filter } })
        .then(response => {
            commit("setContacts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function uploadDiscounts({state}) {
    let formData = new FormData();
    formData.append('file', state.file);
    state.loading.module = true ;
    $http.post(`/api/descuentos-por-cliente-marca/importar`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then(function(){
        state.loading.module = false ;
        Notification.success({
            title: "Success!",
            message: 'Archivo cargado',
            type: "success",
            duration: 3000,
            customClass: "notification-box"
        });
    })
        .catch(error => {
            state.loading.module = false ;
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });
        });
}

export async  function getReport({ state }) {
    state.loading.download_report = true
    await $http({
        url: '/api/descargar-descuentos-por-cliente-marca',
        params: {search:state.params.search.toUpperCase()},
        method: 'GET',
        responseType: "blob",
    }).
    then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        let date=Date();
        link.setAttribute("download", `INFORME-DESCEUNTOS-CLIENTE-MARCA-${date.toString()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        state.loading.download_report = false
    }).catch(error => {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
        state.loading.download_report = false
    });
}



// WEBPACK FOOTER //
// ./src/modules/customerDiscountBrand/actions.js